import React from 'react';

// Completely stable SVG loader that never re-renders
const StableSvgLoader = React.memo(() => {
    return (
        <div className="svg-loader-container">
            <object 
                data="/Loader.svg" 
                type="image/svg+xml"
                style={{
                    width: '350px',
                    height:'112px',
                    display: 'block'
                }}
            >
                Loading animation
            </object>
        </div>
    );
});

StableSvgLoader.displayName = 'StableSvgLoader';

export default StableSvgLoader;